import { StandardEvents } from '@shopify/events';

/**
 * Alinga | 08-10-2026
 * Keeps the 3D builder link's `defaults` parameter in sync with the selected variant SKU,
 * so the configurator opens on the exact finish/size the customer has chosen.
 * The start stage is resolved in Liquid (blocks/_page-builder-link.liquid) and left untouched.
 */
const initialised = new WeakSet();

const init = () => {
  document.querySelectorAll('a[data-page-builder-link]').forEach((link) => {
    if (!(link instanceof HTMLAnchorElement) || initialised.has(link)) return;

    const target = link.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    if (!target) return;
    initialised.add(link);

    target.addEventListener(StandardEvents.productSelect, (event) => {
      event.promise
        ?.then(({ detail }) => {
          const sku = detail?.resource?.sku;
          if (!sku) return;

          const url = new URL(link.href);
          url.searchParams.set('defaults', sku);
          link.href = url.toString();
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[page-builder-link] Event promise rejected:', error);
        });
    });
  });
};

init();
document.addEventListener('shopify:section:load', init);
